import TypographyRebrand, {
  TypographyRebrandProps
} from 'src/components/atoms/TypographyRebrand/TypographyRebrand'
import { CtaBandRebrandResult } from 'src/components/layouts/Page/SanityContentPage/types'
import {
  CmsCtaButtonRebrand,
  CmsCtaButtonRebrandProps
} from 'src/components/molecules/CmsCtaButtonRebrand'

type TextColor = NonNullable<TypographyRebrandProps['color']>

type BackgroundStyle =
  | { kind: 'color'; className: string; textColor: TextColor }
  | {
      kind: 'pattern'
      src: string
      overlayClassName?: string
      textColor: TextColor
    }

const BACKGROUND_STYLES: Record<
  NonNullable<CtaBandRebrandResult['color']>,
  BackgroundStyle
> = {
  limeBright: {
    kind: 'color',
    className: 'bg-limeBright',
    textColor: 'forestDeep'
  },
  lavenderBright: {
    kind: 'color',
    className: 'bg-lavenderBright',
    textColor: 'forestDeep'
  },
  patternDarkForest: {
    kind: 'pattern',
    src: '/img/hero/patterns/patternDarkForest.png',
    textColor: 'linen'
  },
  patternPurpleForest: {
    kind: 'pattern',
    src: '/img/hero/patterns/patternPurpleForest.png',
    textColor: 'forestDeep'
  }
}

export const CtaBandSectionRebrand = ({
  heading,
  subheading,
  color = 'limeBright',
  buttons
}: CtaBandRebrandResult) => {
  const background = BACKGROUND_STYLES[color]
  const { textColor } = background

  return (
    <section
      className={`px-4 md:px-20 relative w-full overflow-hidden ${
        background.kind === 'color' ? background.className : ''
      }`}
    >
      {background.kind === 'pattern' && (
        <>
          <div
            aria-hidden
            className='absolute inset-0 pointer-events-none bg-cover bg-center'
            style={{ backgroundImage: `url(${background.src})` }}
          />
          {background.overlayClassName && (
            <div
              aria-hidden
              className={`absolute inset-0 pointer-events-none ${background.overlayClassName}`}
            />
          )}
        </>
      )}
      <div className='relative container mx-auto flex flex-col items-start justify-center gap-1.5 px-4 py-16 lg:min-h-[231px] lg:flex-row lg:items-center lg:justify-between lg:gap-6 lg:px-20 lg:py-20'>
        <div className='flex flex-col gap-2.5'>
          {heading && (
            <TypographyRebrand variant='h4' color={textColor}>
              {heading}
            </TypographyRebrand>
          )}
          {subheading && (
            <TypographyRebrand variant='introduction' color={textColor}>
              {subheading}
            </TypographyRebrand>
          )}
        </div>
        {buttons && buttons.length > 0 && (
          /* mb-6 offsets the introduction variant's bottom margin */
          <div
            className={`flex flex-wrap items-center gap-4 ${
              subheading ? 'mb-6' : ''
            }`}
          >
            {buttons.map((button: CmsCtaButtonRebrandProps, idx: number) => (
              <CmsCtaButtonRebrand key={`ctabandrebrand-${idx}`} {...button} />
            ))}
          </div>
        )}
      </div>
    </section>
  )
}

export default CtaBandSectionRebrand
